import { useState } from "react";
import { errorText, supabase } from "../supabase";

// Plan decision 14: training leads sign in with a link sent to their email, with no
// password. Only people already set up as a training lead get a link; nobody can sign
// themselves up.

export default function SignIn() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState<"idle" | "sending" | "sent">("idle");
  const [error, setError] = useState("");

  async function send(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    setState("sending");
    const { error } = await supabase.auth.signInWithOtp({
      email: email.trim(),
      options: { shouldCreateUser: false, emailRedirectTo: window.location.origin + window.location.pathname },
    });
    if (error) {
      setState("idle");
      const text = errorText(error);
      if (/signups? not allowed|not found|user/i.test(text)) {
        setError("This email is not set up as a training lead. Ask Chaukas support to add you.");
      } else if (error.status === 429 || /rate limit|too many/i.test(text)) {
        setError("Too many sign-in emails were sent just now. Please wait a while and try again.");
      } else {
        setError(text);
      }
      return;
    }
    setState("sent");
  }

  return (
    <div className="signin">
      <div className="card">
        <div className="logo">
          <img src="/icon.svg" alt="" />
          Chaukas admin
        </div>
        {state === "sent" ? (
          <>
            <h1>Check your email</h1>
            <p>
              We sent a sign-in link to <strong>{email.trim()}</strong>. Open it on this computer to sign in. The link
              works once and expires after an hour.
            </p>
            <button className="link-btn" onClick={() => setState("idle")}>
              Use a different email
            </button>
          </>
        ) : (
          <form className="stack" onSubmit={send}>
            <h1>Sign in</h1>
            <p className="muted">For training leads and operations heads. We email you a link, so there is no password.</p>
            <label className="field">
              Work email
              <input
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </label>
            {error && <div className="notice error">{error}</div>}
            <button className="btn" disabled={state === "sending" || !email.trim()}>
              {state === "sending" ? "Sending…" : "Email me a sign-in link"}
            </button>
          </form>
        )}
        <p className="muted small">Practice scores guide coaching. They are never used for discipline or pay.</p>
      </div>
    </div>
  );
}
